export default {
  Form: {
    parts: ['requiredIndicator', 'helperText'],
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
